import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { extensionInstallIdSchema } from "./claim-request";

const questionTypeSchema = z.enum(["number", "text", "boolean", "single-select", "multi-select"]);

const questionSchema = z.object({
  label: z.string().min(1).max(500),
  type: questionTypeSchema,
  options: z.array(z.string()).optional(),
});

export const answerQuestionRequestSchema = z.object({
  applicationId: z.string().min(1),
  installId: extensionInstallIdSchema,
  questions: z.array(questionSchema).min(1),
});

export class AnswerQuestionRequestDto extends createZodDto(answerQuestionRequestSchema) {}

const answerItemSchema = z.object({
  label: z.string(),
  answer: z.string(),
  confidence: z.enum(["high", "low"]),
});

export const answerQuestionResponseSchema = z.object({
  answers: z.array(answerItemSchema),
});

export type AnswerQuestionResponseDto = z.infer<typeof answerQuestionResponseSchema>;
export type AnswerItemDto = z.infer<typeof answerItemSchema>;
export type QuestionDto = z.infer<typeof questionSchema>;
